<template>
  <div class="hello">
    <div class="wechat-user-logo">
      <img :src="user.userlogo" />
    </div>
    <div class="title1">{{user.username}}</div>
    <div class="title2">
      已绑定手机号：{{user.userphone}}，可接收单位设备的报警信息。
    </div>
    <div class="tip">* 解绑可更换手机号。</div>
    <button class="btn-gray" @click="unbindWeChat">解绑</button>
  </div>
</template>
<script>
import { MessageBox } from 'mint-ui';
export default {
  name: "bindDetail",
  data() {
    return {
      isShow:false,
      request:{
        phone:"",
        openId:""
      },
      user:{}
    };
  },
  mounted(){
    this.request.openId=this.$route.query.openId;
    if(this.request.openId){
      this.getUserInfo();
    }
  },
  methods:{
    //调用接口查询要绑定的用户信息
    getUserInfo(){
      //如果查询到则弹出是否绑定确认框,否则提示无此账号
      var _t=this;
      this.common.doActionGet(
        this.common.bindIsOk,
        {openId:this.request.openId},
        function(res){
          console.log(res);
          if(res.code==200){
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            _t.user=res.data;
            _t.request.phone=res.data.userphone;
          }else if(res.code==201){
            //未绑定微信
            var query = {
                openId: _t.request.openId
              };
              _t.$router.push({
                path: "/bindPhone",
                query: query
              });
          }
          else{
            MessageBox.alert(res.msg,'ERROR');
          }
      },
      "weixin");
      this.isShow=true;
    },
    unbindWeChat(){
      var _t=this;
      MessageBox.confirm('解绑后将不再接受单位设备的报警信息！').then(action => {
          _t.common.doActionGet(
          _t.common.removeBindLny,
          _t.request,
          function(res){
            if(res.code==200){
              //绑定成功,跳转到详情页bindDetail,否则提示失败原因
                var query = {
                  openId: _t.request.openId
                };
                _t.$router.push({
                  path: "/bindPhone",
                  query: query
                });
            }else{
              MessageBox.alert(res.msg,'ERROR');
            }
        },
      "weixin");
      }).catch(_ => {});
    }
  }
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";
.hello {
  height: 100%;
  padding:0px 20px;
}
.title1{
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-top:20px;
}
.title2{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top:75px;
  text-align: left;
}
.tip{
  font-size: 14px;
  color: #999999;
  text-align: left;
  margin-top:14px;
}
.btn-code{
  width: 80px;
  height: 26px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #007AFF;
  color: #007AFF;
  font-size: 12px;
}
.btn-gray{
  width:100%;
  height: 40px;
  margin-top:100px;
}
.wechat-user-logo{
  margin-top:80px;
}
</style>



// WEBPACK FOOTER //
// src/components/wechat/bindDetail.vue